export const iconFontAwesomeUsersPeoplePersonWalkingLuggage = (
	<i className="fa-solid fa-person-walking-luggage"></i>
);
